import Inner from "@/views/Inner.vue";
import NotFound from '@/views/NotFound.vue';
import Login from "@/views/backstage/login/index.vue";
import Dengdai from "@/views/backstage/Dengdai/index.vue";

const defaultRoutes: any = [
   
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: NotFound
  },
  {
    path: '/login',
    name: '登录',
    meta: {
      title: '登录',
      icon: 'el-icon-s-home'
    },
    component: Login
  },
  {
    path: '/dengdai',
    name: '官网',
    meta: {
      title: '官网',
      icon: 'el-icon-s-home'
    },
    component: Dengdai
  },
  {
    path: '/backStageHome',
    name: '后台管理系统',
    meta: {
      title: 'route.homeTitle',
      icon: 'el-icon-s-home'
    },
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: '/backstage/menu',
        name: '菜单管理',
        meta: {
          title: '菜单管理',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/system/menu/Index.vue')
      },
      {
        path: '/backstage/log',
        name: '系统日志',
        meta: {
          title: '系统日志',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/system/log/Index.vue')
      },
      {
        path: '/backstage/parameter',
        name: '系统参数',
        meta: {
          title: '系统参数',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/system/parameter/Index.vue')
      },
      {
        path: '/backstage/enum',
        name: '枚举类型',
        meta: {
          title: '枚举类型',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/system/enum/Index.vue')
      },
      {
        path: '/backstage/user',
        name: '用户信息',
        meta: {
          title: '用户信息',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/user/Index.vue')
      },
      {
        path: '/backstage/user/edit',
        name: '编辑用户',
        meta: {
          title: '编辑用户',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/user/Edit.vue')
      },
      {
        path: '/backstage/user/add',
        name: '新增用户',
        meta: {
          title: '新增用户',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/user/Edit.vue')
      },
      {
        path: '/backstage/role',
        name: '角色管理',
        meta: {
          title: '角色管理',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/user/role/Index.vue')
      },
      {
        path: '/backstage/depart',
        name: '部门管理',
        meta: {
          title: '部门管理',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/base/depart/Index.vue')
      },
      {
        path: '/backstage/post',
        name: '职位管理',
        meta: {
          title: '职位管理',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/base/post/Index.vue')
      },
      {
        path: '/backstage/schemeType',
        name: '方案类型管理',
        meta: {
          title: '方案类型管理',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/base/scheme/Index.vue')
      },
      {
        path: '/backstage/recruitType',
        name: '招聘类型管理',
        meta: {
          title: '招聘类型管理',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/base/recruit/Index.vue')
      },
      {
        path: '/backstage/scene',
        name: '应用场景',
        meta: {
          title: '应用场景',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/base/usage/Index.vue')
      },
      {
        path: '/backstage/InvestmentType',
        name: '招商类型',
        meta: {
          title: '招商类型',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/base/investment/Index.vue')
      },
      {
        path: '/backstage/gallery',
        name: '数字展厅',
        meta: {
          title: '数字展厅',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/business/gallery/Index.vue')
      },
      {
        path: '/backstage/news',
        name: '新闻公告',
        meta: {
          title: '新闻公告',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/business/news/Index.vue')
      },
      {
        path: '/backstage/news/edit',
        name: '编辑新闻',
        meta: {
          title: '编辑新闻',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/business/news/Edit.vue')
      },
      {
        path: '/backstage/news/add',
        name: '新增新闻',
        meta: {
          title: '新增新闻',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/business/news/Edit.vue')
      },
      {
        path: '/backstage/recruit',
        name: '招聘管理',
        meta: {
          title: '招聘管理',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/business/recruit/Index.vue')
      },
      {
        path: '/backstage/message',
        name: '留言板',
        meta: {
          title: '留言板',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/business/message/Index.vue')
      }, 
      {
        path: '/backstage/attract',
        name: '招商加盟',
        meta: {
          title: '招商加盟',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/business/attract/Index.vue')
      },
      {
        path: '/backstage/classicCustomer',
        name: '经典客户',
        meta: {
          title: '经典客户',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/business/custom/Index.vue')
      },
      {
        path: '/backstage/activeSupport',
        name: '活动支持',
        meta: {
          title: '活动支持',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/business/active/Index.vue')
      },{
        path: '/backstage/usageCase',
        name: '应用案例',
        meta: {
          title: '应用案例',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/business/usage/Index.vue')
      },{
        path: '/backstage/solution',
        name: '解决方案管理',
        meta: {
          title: '解决方案',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/business/solution/Index.vue')
      }, {
        path: '/backstage/product',
        name: '产品管理',
        meta: {
          title: '产品管理',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/business/product/Index.vue')
      },
      {
        path: '/backstage/product/edit',
        name: '编辑产品管理',
        meta: {
          title: '编辑产品管理',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/business/product/Edit.vue')
      },
      {
        path: '/backstage/product/add',
        name: '新增产品管理',
        meta: {
          title: '新增产品管理',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/business/product/Edit.vue')
      },{
        path: '/backstage/aboutUs',
        name: '关于我们',
        meta: {
          title: '关于我们',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/business/about/Index.vue')
      },
      {
        path: '/backstage/aboutUs/edit',
        name: '编辑关于我们',
        meta: {
          title: '编辑关于我们',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/business/about/Edit.vue')
      },
      {
        path: '/backstage/aboutUs/add',
        name: '新增关于我们',
        meta: {
          title: '新增关于我们',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/business/about/Edit.vue')
      },{
        path: '/backstage/cooperative',
        name: '合作流程',
        meta: {
          title: '合作流程',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/base/cooperative/Index.vue')
      },{
        path: '/backstage/apply',
        name: '代理申请',
        meta: {
          title: '代理申请',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/business/apply/Index.vue')
      },{
        path: '/backstage/examTest',
        name: '问卷管理',
        meta: {
          title: '问卷管理',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/exam/examTest.vue')
      },{
        path: '/backstage/examTestDetails',
        name: '问卷管理详情',
        meta: {
          title: '问卷管理详情',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/exam/examTestDetails.vue')
      },{
        path: '/backstage/examQuestion',
        name: '题库管理',
        meta: {
          title: '题库管理',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/exam/examQuestion.vue')
      },{
        path: '/backstage/examQuestionDetails',
        name: '题库管理详情',
        meta: {
          title: '题库管理详情',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/exam/examQuestionDetails.vue')
      },{
        path: '/backstage/questionsDetails',
        name: '问答记录详情',
        meta: {
          title: '问答记录详情',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/exam/questionsDetails.vue')
      }
      ,{
        path: '/backstage/questionnaireStatistics',
        name: '问卷统计',
        meta: {
          title: '问卷统计',
          icon: 'el-icon-s-home'
        },
        component: () => import('@/views/backstage/exam/questionnaireStatistics.vue')
      }
      
    ]
  },

];

export default defaultRoutes;
